import { useCallback, memo } from 'react'
import { useDispatch } from 'react-redux'
import { doUpsertAiConversationSuggestions } from 'ducks/ai/operations'

import ResetIcon from '@groovehq/internal-design-system/lib/assets/icons/Reset'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'

import { styles } from './styles'

const RegenerateButton = ({ ticketId, suggestionTypes, isLoading }) => {
  const dispatch = useDispatch()

  const onRegenerate = useCallback(
    event => {
      event.stopPropagation()

      dispatch(
        doUpsertAiConversationSuggestions({
          suggestionTypes,
          ticketId,
        })
      )
    },
    [dispatch, ticketId, suggestionTypes]
  )

  if (isLoading) {
    return null
  }

  return (
    <Button
      className="grui absolute"
      type="tertiary"
      size="small"
      onClick={onRegenerate}
      css={styles.button}
      customIcon={<ResetIcon />}
    >
      Regenerate
    </Button>
  )
}

export default memo(RegenerateButton)
